import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/Button.js";
import { EmptyState } from "../components/ui/EmptyState.js";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="py-16">
      <EmptyState
        icon={<i className="pi pi-exclamation-triangle text-2xl" />}
        title={t("notFound.title")}
        message={t("notFound.message")}
        action={
          <Button as={Link} to="/" variant="outlined" severity="secondary">
            {t("notFound.backHome")}
          </Button>
        }
      />
    </div>
  );
}
